import { notEmpty } from '../../utils/validator'

export default {
  className: 'storageInfo',
  tableSize: 'small',
  fields: [
    {
      name: 'name',
      validators: [
        notEmpty()
      ]
    }
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.types = 'grain'
    },
    beforeSave ({ data }) {
      data.types = 'grain'
    }
  },
  action: {
    create: {
      icon: ''
    },
    export: {
      icon: ''
    }
  }
}
